import { createSlice } from "@reduxjs/toolkit";
import { getContestCommentsThunk,saveContestCommentsThunk} from "./thunk";


export const initialState = {
  comments: [],
  error: null,
  isLoading: false,
  isSaving: false,
  isCommentSave:false
};

const UserSlice = createSlice({
  name: "comments",
  initialState,
  reducers: {
    resetFlags: (state) => {
      
      state.isSuccess = false;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {


    // Get Comments
    builder.addCase(getContestCommentsThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getContestCommentsThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.comments = action.payload.data;
    });
    builder.addCase(getContestCommentsThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.comments =[];
      state.error = action.payload || "Something went wrong";
    });

        // Save Comments
    builder.addCase(saveContestCommentsThunk.pending, (state) => {
      state.isSaving = true;
      state.error = null;
      state.isCommentSave=false;
    });
    builder.addCase(saveContestCommentsThunk.fulfilled, (state, action) => {
      state.isSaving = false;
      state.isCommentSave =true;
    });
    builder.addCase(saveContestCommentsThunk.rejected, (state, action) => {
      state.isSaving = false;
      state.isCommentSave=true
      state.error = action.payload || "Something went wrong";
    });


  },
});

export const { resetFlags } = UserSlice.actions;
export default UserSlice.reducer;
